import React, { Component } from "react";
import Store from "redux/store";
import { Provider } from "react-redux";
import { Router } from "@reach/router";
import Landing from "components/Landing";
import ErrorBoundary from "components/common/ErrorBoundary";
import ErrorModal from "components/common/ErrorModal";

window.__WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER;
window.__CONTACT_DEV_URL = process.env.REACT_APP_CONTACT_DEV_URL;

export default class App extends Component {
  render() {
    return (
      <>
        <ErrorBoundary>
          <Provider store={Store}>
            <Router>
              <Landing path="/*" default />
            </Router>
          </Provider>
        </ErrorBoundary>
        <ErrorModal />
      </>
    );
  }
}
// for debugging purpose of getting the value of the store in the redux
window.store = Store;
